type ContentTab = 'audio' | 'video' | 'resources' | 'collections';

export const resetPageForTab = (
  tab: ContentTab,
  setAudioPage: (page: number) => void,
  setVideoPage: (page: number) => void,
  setResourcesPage: (page: number) => void,
  setCollectionsPage: (page: number) => void,
) => {
  if (tab === 'audio') {
    setAudioPage(1);
  } else if (tab === 'video') {
    setVideoPage(1);
  } else if (tab === 'resources') {
    setResourcesPage(1);
  } else if (tab === 'collections') {
    setCollectionsPage(1);
  }
};
